import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true, name: 'dialog' })
export default class Dialog extends VuexModule {
	tutorialDialog = false;
	signInDialog = false;
	likersDialog = false;
	likerUids: string[] = [];
	profileEditDialog = false;
	profileDialog = false;
	profileUid = ""

	get isSignInDialogOpen() {
		return this.signInDialog;
	}

	get isLikersDialogOpen() {
		return this.likersDialog;
	}

	@Mutation
	TOGGLE_TUTORIAL_DIALOG(payload: { open: boolean }) {
		this.tutorialDialog = payload.open;
	}

	@Action({ commit: 'TOGGLE_TUTORIAL_DIALOG' })
	toggleTutorialDialog(payload: { open: boolean }) {
		return payload;
	}

	@Mutation
	OPEN_SIGN_IN_DIALOG(payload: { open: boolean }) {
		this.signInDialog = payload.open;
	}

	@Action({ commit: 'OPEN_SIGN_IN_DIALOG' })
	openSignInDialog(payload: { open: boolean }) {
		return payload;
	}

	@Mutation
	OPEN_LIKERS_DIALOG(payload: { open: boolean; likerUids?: string[] }) {
		this.likersDialog = payload.open;
		if (payload.likerUids) this.likerUids = payload.likerUids;
	}

	@Action({ commit: 'OPEN_LIKERS_DIALOG' })
	openLikersDialog(payload: { open: boolean; likerUids?: string[] }) {
		return payload;
	}

	@Mutation
	OPEN_PROFILE_EDIT_DIALOG(payload: { open: boolean }) {
		this.profileEditDialog = payload.open;
	}

	@Action({ commit: 'OPEN_PROFILE_EDIT_DIALOG' })
	openProfileEditDialog(payload: { open: boolean }) {
		return payload;
	}

	@Mutation
	OPEN_PROFILE_DIALOG(payload: { open: boolean, uid: string }) {
		this.profileDialog = payload.open;
		this.profileUid = payload.uid
	}

	@Action({ commit: 'OPEN_PROFILE_DIALOG' })
	openProfileDialog(payload: { open: boolean, uid: string }) {
		return payload;
	}
}
